import Chip from "@mui/material/Chip"
import { styled } from "@mui/material/styles"

import GlassMixin from "../../../common/components/GlassMixin"

export default styled(Chip)(({ theme }) => ({
  borderRadius: "16px",
  ...GlassMixin,
  boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 8px",
  color: "#0a2540",
}))
